
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, dashboardLimit, milkType, buySellType, animalType, fuelType, otherType, usageType} from "../../../comman/config.js";
import Loader from "../../../comman/Loader";
import {DateFilter} from "../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";

function Dashboard() {

    const [profitList, setProfitList] = useState([]);
    const [totalIncome, setTotalIncome] = useState(0);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [totalExpense, setTotalExpense] = useState(0);
    const [sellTotalItem, setSellTotalItem] = useState(0);
    
    const [lostList, setLostList] = useState([]);
    const [lostPage, setLostPage] = useState(1);
    const [notificationList, setNotificationList] = useState([]);


    useEffect(() => {
        getNotificationList();
    }, []);
    useEffect(() => {
        if(fromDate && toDate){
            getProfitDetail();
        }
        
    }, [page, fromDate,toDate]);

    useEffect(() => {
        if(fromDate && toDate){
            getLostDetail();
        }
        
        
    }, [lostPage, fromDate,toDate]);


    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }
    const handleSellPageChange = (pageNumber) => {
        setLostPage(pageNumber);
    }

    const getProfitDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/farm/dashboard/profit_list?page=${page}&limit=${dashboardLimit}&fromDate=${fromDate}&toDate=${toDate}`);
        setPopupOpen(false);
        const detailList = response.data.data;
        
        
        setProfitList(detailList);
        setTotalItem(response.data.totalItem);
        setTotalIncome(response.data.profitTotal ?? 0)
    }

    const getLostDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/farm/dashboard/loss_list?page=${lostPage}&limit=${dashboardLimit}&fromDate=${fromDate}&toDate=${toDate}`);
        setPopupOpen(false);
        setTotalExpense(response.data.lossTotal ?? 0);
        setLostList(response.data.data);
        setSellTotalItem(response.data.totalItem);
        
    }


    

    const handelFilterChange= (fromDate, toDate, clear, today) => {
        if(clear){
            setFromDate(today);
            setToDate(today); 
        }else{
            setFromDate(fromDate);
            setToDate(toDate); 
        }
        
    };

    const getProuctName = (item) => {
       
        if(item.product_type == 1){
            return milkType.find((val) => val.value == item.milk_type)?.label ?? "-"
        }else{
            return item.product_name;
        }
    }

    const getNotificationList = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/dashboard/notification`);
        setPopupOpen(false);
        setNotificationList(response.data.data);
    }

    const getLostName = (item) => {
        if(item.type == "salary"){
            return item.name;
        }else if(item.type == "fuel"){
            const fuel = fuelType.find((val) => val.value ==item.fuel_type)?.label ?? "";
            const type = usageType.find((val) => val.value == item.usage_type)?.label ?? "";
            return `${fuel} ${type ? `(${type})` : ""}`;
        }else if(item.type == "medical" || item.type == "feed"){
            return `${item.name} ${item.company_name ? `(${item.company_name})` : ""}`;
        }else if(item.type == "other"){
            const category = otherType.find((val) => val.value == item.other_type)?.label ?? "";
            return category ?? "";
        }else if(item.type == "animal" ){
            const type = animalType.find((val) => val.value == item.animal_type)?.label ?? "";
            const category = buySellType.find((val) => val.value == item.other_type)?.label ?? "";
            return `${type} ${category ? `(${category})` : ""}`;
        }else if(item.type == "milk" ){
            const type = animalType.find((val) => val.value == item.animal_type)?.label ?? "";
            return `${type} (Distributor)`;
        }
    }

    const getProfitName = (item) => {
        if(item.type == "other"){
            const category = otherType.find((val) => val.value == item.other_type)?.label ?? "";
            return category ?? "";
        }else if(item.type == "animal" ){
            const type = animalType.find((val) => val.value == item.animal_type)?.label ?? "";
            const category = buySellType.find((val) => val.value == item.other_type)?.label ?? "";
            return `${type} ${category ? `(${category})` : ""}`;
        }else if(item.type == "distributor"){
            const type = animalType.find((val) => val.value == item.animal_type)?.label ?? "";
            return `${type} (Distributor)`;
        }
    }

    const getDateList = (datelist) => {

        const currentDate = new Date();

        // Format the date as YYYY-MM-DD
        const formattedDate = currentDate.toISOString().split('T')[0];

        const dateList = JSON.parse(datelist);
        return dateList.filter((val) => val != formattedDate).map((val) => val).join(", ");
    }

    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Dashboard</h1>
              
            </div>
            
            <div className="relative overflow-x-auto ">
    <DateFilter handleFilterChange={handelFilterChange} />
    
    
    <div className="mt-4 px-2 mb-4">
        <div className="border rounded-lg shadow p-4 ">
            {/* <strong className="text-lg">Totals</strong> */}
            <div className="flex justify-between mt-2 text-lg">
                <div className="text-gray-700">Total Expense: 
                    <span className="font-bold text-green-600"> {totalExpense}</span>
                </div>
                <div className="text-gray-700">Total Income: 
                    <span className="font-bold text-green-600"> {totalIncome}</span>
                </div>
                <div className={`font-bold ${totalIncome - totalExpense > 0 ? 'text-green-500' : 'text-red-500'}`}>
                    {totalIncome - totalExpense > 0 
                        ? `Profit: ${totalIncome - totalExpense}` 
                        : `Loss: ${totalExpense - totalIncome}`}
                </div>
            </div>
        </div>
    </div>
    <div className="flex justify-between">
      
    <div className="w-1/2 px-2">
            <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                <strong>Expense</strong>
                
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr >
                            <th scope="col" className="px-6 py-3 border">Date</th>
                            <th scope="col" className="px-6 py-3 border">Name</th>
                            <th scope="col" className="px-6 py-3 border">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lostList.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                                <td className="px-6 py-4">{getLostName(item)}</td>
                                <td className="px-6 py-4">{item.price}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {sellTotalItem > dashboardLimit && (<Pagination
              activePage={lostPage}
              itemsCountPerPage={dashboardLimit}
              totalItemsCount={sellTotalItem}
              pageRangeDisplayed={5}
              onChange={handleSellPageChange.bind(this)}
            />)}
            </div>
        </div>
        <div className="w-1/2 px-2">
            <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                <strong>Income</strong>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3 border">Date</th>
                            <th scope="col" className="px-6 py-3 border">Name</th>
                            <th scope="col" className="px-6 py-3 border">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {profitList.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                            <td className="px-6 py-4">{getProfitName(item)}</td>
                            <td className="px-6 py-4">{item.price}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
                {totalItem > dashboardLimit && (<Pagination
              activePage={page}
              itemsCountPerPage={dashboardLimit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
            </div>
        </div>

        
    </div>
    <div className="py-10">
                <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                    <strong>Notification</strong>
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3 border">Date</th>
                                <th scope="col" className="px-6 py-3 border">Future Date List</th>
                                <th scope="col" className="px-6 py-3 border">Animal Type</th>
                                <th scope="col" className="px-6 py-3 border">Animal Id</th>
                                <th scope="col" className="px-6 py-3 border">Shed No.</th>
                                <th scope="col" className="px-6 py-3 border">Description</th>

                            </tr>
                        </thead>
                        <tbody>
                            {notificationList.map((item, index) => (
                                <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                    <th className="px-6 py-4">{new Date().toISOString().split('T')[0]}</th>
                                    <th className="px-6 py-4">{getDateList(item.date)}</th>
                                    <th className="px-6 py-4">{animalType.find((val) => val.value ==item.animal_type)?.label ?? ""}</th>
                                    <td className="px-6 py-4">{item.animal_id}</td>
                                    <td className="px-6 py-4">{item.shed_no}</td> 
                                    <td className="px-6 py-4">{item.description}</td> 

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
    
</div>

            
            {/* <div>
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Due Salary Dashboard</h1>
                
            </div> 
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg"> */}
                
                {/* <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Month</th>
                        <th scope="col" className="px-6 py-3 border">Staff</th>
                        <th scope="col" className="px-6 py-3 border">Salary</th>
                        <th scope="col" className="px-6 py-3 border">Upaad</th>
                        <th scope="col" className="px-6 py-3 border">Due Salary</th>
                        </tr>
                       
                    </thead>
                    <tbody>
                    {lostList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.month}</th>
                            <td className="px-6 py-4">{item.name}</td>
                            <td className="px-6 py-4">{item.salary}</td>
                            <td className="px-6 py-4">{item.total_upaad}</td> 
                            <td className="px-6 py-4">{(item.salary - item.total_upaad).toFixed(2)}</td> 
                           
                            
                        </tr>))}
           
                    </tbody>
                </table> */}
            {/* </div> */}
            {/* {sellTotalItem > limit && (<Pagination
              activePage={lostPage}
              itemsCountPerPage={limit}
              totalItemsCount={sellTotalItem}
              pageRangeDisplayed={5}
              onChange={handleSellPageChange.bind(this)}
            />)} */}
            {/* </div> */}
        </div>
        
  );
}

export default Dashboard;